<template>
    <div class="materi-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col-lg-6">
                                <h6 class="text-uppercase ls-1 mb-1">Perkembangan Siswa{{studentProgressList.semester}}{{studentProgressList.subject_name}}{{studentProgressList.activity_name}} </h6>
                            </div>
                            <div class="col-lg-6 text-lg-right">
                                
                            </div>
                        </div>
                        <div class="text-center text-muted">
                            <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                                <div class="p-2">
                                    <b-row>
                                        <b-col lg="3" class="my-1">
                                            <b-button 
                                                variant="primary" 
                                                :disabled="!studentProgressList.body" 
                                                style="border-radius:0px !important;" 
                                                class="btn btn-danger" 
                                                @click="downloadExcel(filter_form)">
                                                Download Excel
                                            </b-button>
                                        </b-col>
                                        <b-col lg="1" class="my-1">
                                        </b-col>
                                        <b-col lg="2" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="filter_form.taId"
                                                    name="taId"
                                                    v-validate="'required'"
                                                    value-field="id"
                                                    placeholder="Tahun Ajaran"
                                                    text-field="name"
                                                    data-vv-as="Tahun Ajaran"
                                                    :options="taList"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="2" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="filter_form.activityId"
                                                    name="activityId"
                                                    v-validate="'required'"
                                                    value-field="id"
                                                    placeholder="Kegiatan Belajar"
                                                    text-field="name"
                                                    data-vv-as="Kegiatan Belajar"
                                                    :options="activityList"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Pilih Kegiatan Belajar</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="4" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="filter_form.userId"
                                                    name="userId"
                                                    v-validate="'required'"
                                                    value-field="id"
                                                    placeholder="Nama User"
                                                    text-field="name"
                                                    data-vv-as="Nama User"
                                                    :options="userListByLA"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Pilih User</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <b-input-group-append>
                                                    <b-button variant="primary" :disabled="!filter_form.userId || !filter_form.activityId" style="border-radius:0px !important;" class="btn btn-primary" @click="getStudentProgressList(filter_form)">Filter</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <div style="overflow-x:auto;" v-if="!isBusy">
                                        <table id="student-progress" class="table table-perkembangan"
                                            :current-page="currentPage"
                                            :per-page="perPage"
                                            :filter="filter"
                                            :filter-included-fields="filterOn"
                                            :sort-direction="sortDirection"
                                            responsive="sm"
                                            show-empty
                                            small
                                            @filtered="onFiltered"
                                        >
                                            <thead>
                                                <tr v-for="(item, index) in studentProgressList.header" :key="index">
                                                    <th class="t-column-header" v-bind:rowspan="column.rowspan" v-bind:colspan="column.colspan" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{column.label}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!studentProgressList.body" class="text-center">
                                                    <td colspan="15">Data tidak ditemukan</td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in studentProgressList.body" :key="index">
                                                    <td class="t-column-body" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{column.label}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="isBusy" class="text-center text-danger my-2">
                                        <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import axios from '../../../axiosHelper';
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
        },
        data() {
            return {
                subjectId: this.$route.params.subjectId,
                isBusy: false,
                showLoader: false,
                items: [
                    { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
                    { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
                    {
                        isActive: false,
                        age: 9,
                        name: { first: 'Mini', last: 'Navarro' },
                        _rowVariant: 'success'
                    },
                    { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
                    { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
                    { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
                    {
                        isActive: true,
                        age: 87,
                        name: { first: 'Larsen', last: 'Shaw' },
                        _cellVariants: { age: 'danger', isActive: 'warning' }
                    },
                    { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
                    { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
                    { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
                ],
                fields: [
                    { key: 'name', label: 'Nama Lengkap', sortable: true, sortDirection: 'desc', class: 'text-left' },
                    { key: 'absence', label: 'Keterangan', sortable: false, class: 'text-center'}
                ],
                filter_form: {
                    taId: null,
                    activityId: null,
                },
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: []
            }
        },
        computed: {
            ...mapGetters({
                studentProgressList: 'getStudentProgressList',
                userListByLA: 'getUserListByLA',
                activityList: 'getActivityList',
                taList: 'getTaList',
                token: 'getToken'
            })
        },
        watch: {
            'filter_form.activityId'(val) {
                this.getUserListByLA(val)
            }
        },
        methods: {
            downloadExcel(param) {
                let token = this.token
                let activityId = param.activityId
                let userId = param.userId
                let taId = param.taId
                let route = axios.defaults.baseURL+'/v1/student-progress/download/'+activityId+'/'+userId+'/'+taId+'?token='+token
                window.open(route);
            },
			onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async getStudentProgressList(form) {
                this.isBusy = true
                let activityId = form.activityId
                let taId = form.taId
                let userId = form.userId
				await this.$store.dispatch('getStudentProgressList', { activityId,userId,taId })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getUserListByLA(activityId) {
                this.isBusy = true
                
				await this.$store.dispatch('getUserListByLA', { activityId })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getActivityList() {
                this.isBusy = true
                let subjectId = this.subjectId;
				await this.$store.dispatch('getActivityList',{subjectId})
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getTaList() {
                this.isBusy = true
                let subjectId = this.subjectId;
				await this.$store.dispatch('getTaList',{subjectId})
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        destroyed() {
            let resp = null
            this.$store.commit('setStudentProgressList', { resp })
            this.$store.commit('setUserListByLA', { resp })
        },
        mounted() {
            this.totalRows = this.studentProgressList.length
        },
        async created() {
            await this.getActivityList();
            await this.getTaList();
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
.table-perkembangan {
    width: 100%;
    margin: 20px auto;
    table-layout: auto;
    border: 1px solid #555;
    border-width: 0 1px 0 1px;
}
.t-column-header {
    border: 1px solid #555;
    border-width: 0px 1px 0px 1px;
}
.t-column-body {
    border: 1px solid #555;
    border-width: 1px 1px 1px 1px;
}

</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
#student-progress {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#student-progress td, #student-progress th {
  border: 1px solid #ddd;
  padding: 8px;
}

#student-progress tr:nth-child(even){background-color: #f2f2f2;}

#student-progress tr:hover {background-color: #ddd;}

#student-progress th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
</style>